export default "__VITE_ASSET__B6jvER_qafR8TG3SeLApzQ__"